<template>
    <b-button
            class="align-self-start align-middle mr-2 mr-sm-3 py-1 px-2 text-nowrap"
            variant="outline-primary"
            @click="$emit('click')"
    >
        <font-awesome-icon
            :icon="['fas', 'times-circle']"
            class="mr-sm-1"
        ></font-awesome-icon>
        <span class="d-none d-sm-inline-block ml-1">
            Clear Filters
        </span>
    </b-button>
</template>

<script>
    export default {
        name: 'Reset-filters',
    };
</script>
